// API Configuration
// This is the single source of truth for API endpoints
// Configure backend URLs in .env file using REACT_APP_API_BASE_URL and REACT_APP_STORAGE_URL
// Fallback values are provided for development

// Get environment variables or use defaults
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://nuz.mooo.com/api';
const STORAGE_BASE_URL = process.env.REACT_APP_STORAGE_URL || 'https://nuz.mooo.com/storage';

export const API_CONFIG = {
  // Dynamic URLs based on environment
  BASE_URL: API_BASE_URL,
  STORAGE_URL: STORAGE_BASE_URL,
} as const;

// Helper function to get full API URL
export const getApiUrl = (endpoint: string = '') => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get storage URL for images/files
export const getStorageUrl = (path: string) => {
  if (!path) return '';
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_CONFIG.STORAGE_URL}/${cleanPath}`;
};

export default API_CONFIG;
